import PropTypes from "prop-types"
import { size } from "lodash"
import { Button, Badge } from "@mui/material"
import { FilterList } from "@mui/icons-material"

export default function FilterButton({ filters, ...props }) {
  return <Button
    {...props}
    startIcon={<Badge
      overlap="rectangular"
      anchorOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      badgeContent={size(filters)}
      color="primary"
    >
      <FilterList />
    </Badge>}
  >
    Filters
  </Button>
}

FilterButton.propTypes = {
  filters: PropTypes.array.isRequired,
}
